import React, { useState } from 'react';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { services, ServiceKey } from '../data/services';
import { PHONE_DISPLAY, PHONE_HREF } from '../data/site';
const steps = [{
  title: 'Tell us about the job',
  text: 'Share the vehicle, room or building and what happened to the glass.'
}, {
  title: 'Confirm details & measurements',
  text: 'We review options, then take exact measurements when the job needs them.'
}, {
  title: 'Schedule the right service',
  text: 'We book the service and technician suited to your glass and timing.'
}];
export function QuotePath() {
  const [selected, setSelected] = useState<ServiceKey>('auto');
  const service = services.find(s => s.key === selected) ?? services[0];
  return <section id="quote" aria-labelledby="quote-heading" className="w-full bg-white" data-id="element-187" data-mp="15d5uupi4lpu7">
      <div className="mx-auto max-w-shell px-[18px] py-12 sm:px-6 lg:py-20" data-id="element-188" data-mp="15f8ttz19atb2">
        <h2 id="quote-heading" className="max-w-[640px] text-[28px] font-bold leading-tight text-kosin-charcoal lg:text-[36px]" data-id="element-189" data-mp="1adae2naf4yo4">
          From first question to finished glass
        </h2>

        <div className="mt-9 grid grid-cols-1 gap-10 lg:grid-cols-[1.2fr_1fr] lg:gap-16" data-id="element-190" data-mp="13ej79oc8c5dg">
          <ol className="divide-y divide-kosin-line border-t border-kosin-line" data-id="element-191" data-mp="1i7cp3gez4xla">
            {steps.map((step, i) => <li key={step.title} className="flex gap-5 py-6" data-id="element-192" data-mp="1r9u8zo75pe54" data-mpi={i}>
                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-kosin-charcoal text-[14px] font-semibold text-white" aria-hidden="true" data-id="element-193" data-mp="1r8aploq7emz4">
                  {i + 1}
                </span>
                <div data-id="element-194" data-mp="1w1cb4fkx1kro">
                  <h3 className="text-[19px] font-semibold text-kosin-charcoal" data-id="element-195" data-mp="1w2x4i1vhuxny">
                    {step.title}
                  </h3>
                  <p className="mt-1.5 text-[16px] leading-relaxed text-kosin-body" data-id="element-196" data-mp="25zjoypjwrmpg">
                    {step.text}
                  </p>
                </div>
              </li>)}
          </ol>

          <div className="bg-kosin-mist p-6 sm:p-8" data-id="element-197" data-mp="2i0hza8bppp20">
            <h3 className="text-[20px] font-semibold text-kosin-charcoal" data-id="element-198" data-mp="2hz6x2cxx0pd0">
              Start a free quote
            </h3>
            <p className="mt-2 text-[16px] leading-relaxed text-kosin-body" data-id="element-199" data-mp="2rquhhtw2164z">
              Get an estimate for your vehicle, home or commercial project.
            </p>

            <label htmlFor="quote-service" className="mt-6 block text-[14px] font-semibold text-kosin-charcoal" data-id="element-200" data-mp="2vushs7x48mzm">
              What kind of glass?
            </label>
            <select id="quote-service" value={selected} onChange={e => setSelected(e.target.value as ServiceKey)} className="mt-2 w-full rounded border border-kosin-line bg-white px-4 py-3 text-[16px] text-kosin-ink" data-id="element-201" data-mp="35p176mqunztk">
              {services.map(s => <option key={s.key} value={s.key} data-id="element-202" data-mp="3tmqrr3hc1e9k">
                  {s.title}
                </option>)}
            </select>

            <a href={service.quoteHref} className="mt-4 flex items-center justify-center gap-2 rounded bg-kosin-red px-6 py-3.5 text-[16px] font-semibold text-white hover:bg-kosin-bright transition-colors duration-150 ease-kosin" data-id="element-203" data-mp="3otxokk1iidzl">
              Continue to quote
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-204" data-mp="gf5l2f7rbz2w" />
            </a>

            <p className="mt-5 text-[15px] text-kosin-body" data-id="element-205" data-mp="cfevgetyvozy">
              Prefer to talk it through?
            </p>
            <a href={PHONE_HREF} className="mt-1.5 inline-flex items-center gap-2 text-[17px] font-semibold text-kosin-charcoal hover:text-kosin-red transition-colors duration-150 ease-kosin" data-id="element-206" data-mp="7d62hih3gmxu">
              <PhoneIcon className="h-4 w-4 text-kosin-red" aria-hidden="true" data-id="element-207" data-mp="2n6er8vr1fkat" />
              {PHONE_DISPLAY}
            </a>
          </div>
        </div>
      </div>
    </section>;
}